import { memo } from 'react';
import {
  Button,
  Text,
  VStack,
} from 'app/pages/request-single-page/components-v4';
import { useV4Theme } from 'app/pages/request-single-page/components-v4/theme';

import successIcon from '../../../../../assets/success.svg';
import { useResponsive } from 'app/hooks';

type SuccessBodyProps = {
  onCancel: () => void;
};

export const SuccessBody = memo(({ onCancel }: SuccessBodyProps) => {
  const { viewport } = useResponsive();
  const theme = useV4Theme();

  return (
    <VStack flex={1}>
      <VStack flex={1}>
        <VStack padding={24} spacing="xs" center style={{ height: 500 }}>
          <VStack
            center
            style={{
              width: viewport.mobile ? 128 : 180,
              height: viewport.mobile ? 128 : 180,
              borderRadius: theme.radiuses.full,
              backgroundColor: theme.colors.green[100],
            }}
          >
            <img
              src={successIcon}
              alt=""
              style={{
                width: viewport.mobile ? 55 : 85,
                height: viewport.mobile ? 44 : 68,
              }}
            />
          </VStack>
          <Text variant="heading-2" align="center">
            Спасибо! Вложения получены
          </Text>
          <Text variant="body-16" color="gray.500" align="center">
            Это поможет нам лучше понять Вашу проблему и решить её как можно
            скорее
          </Text>
        </VStack>
      </VStack>

      <Button
        mode="accent"
        size="l"
        onClick={onCancel}
        style={{ width: '100%' }}
      >
        Вернуться к заявке
      </Button>
    </VStack>
  );
});
